module.exports = __webpack_public_path__ + "img/DE00868.3c16ed17.png";